export const getRoleIdByName = (roles, name) => {
  const role = roles.find((r) => r.Name === name);
  return role ? role.Id : null;
};

export const getCountryIdByName = (countries, name) => {
  const country = countries.find((c) => c.Name === name);
  return country ? country.Id : null;
};

export const getPrivacyUrlByCountry = (countryId, countries) => {
  const ecuadorId = getCountryIdByName(countries, 'Ecuador');
  const panamaId = getCountryIdByName(countries, 'Panama');

  if (countryId === ecuadorId) {
    return {
      url: 'https://www.esri.co/es-ec/privacidad',
      label: 'Política de Privacidad de Ecuador',
    };
  }

  if (countryId === panamaId) {
    return {
      url: 'https://www.esri.co/es-pa/privacidad',
      label: 'Política de Privacidad de Panama',
    };
  }

  return {
    url: 'https://www.esri.co/es-co/privacidad',
    label: 'Política de Privacidad de Colombia',
  };
};
